// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".playkit-fill-container_Ah{width:100%;height:100%}", "",{"version":3,"sources":["webpack://./src/services/preset-manager/ui/managed-component.scss"],"names":[],"mappings":"AAAA,2BAAgB,UAAU,CAAC,WAAW","sourcesContent":[".fill-container{width:100%;height:100%}"],"sourceRoot":""}]);
// Exports
export var fillContainer = "playkit-fill-container_Ah";
export default ___CSS_LOADER_EXPORT___;
